import React from "react";
import styled from "styled-components";
import { useIntl } from "gatsby-plugin-intl";
import { useStaticQuery, graphql } from "gatsby";
import marked from "marked";

import LanguageMenu from "./languageMenu";
import CollectionNav from "./collectionNav";

const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 1.6rem;
  background-color: ${(props) => props.theme.color.cream};
  border-bottom: 1px solid ${(props) => props.theme.color.grey};
`;

const StyledShippingBanner = styled.div`
  white-space: nowrap;
  box-sizing: content-box;

  ${(props) => props.theme.responsive.desktop} {
    animation: none;
    padding: 0;
  }
`;

const StyledShippingContent = styled.div`
  color: ${(props) => props.theme.color.darkCream};
  font-family: ${(props) => props.theme.font.sans};
  font-size: 0.7rem;
  text-align: center;
  display: inline-block;
  p {
    margin: 0;
  }
`;

export default function NotificationBanner({ location, ...props }) {
  const intl = useIntl();
  const { strapi } = useStaticQuery(graphql`
    query {
      strapi {
        layout {
          topbanner {
            en
            es
            it
          }
        }
      }
    }
  `);
  return (
    <StyledWrapper>
      <CollectionNav location={location} />
      <StyledShippingBanner>
        <StyledShippingContent
          dangerouslySetInnerHTML={{
            __html: marked(strapi?.layout?.topbanner?.[intl.locale] || ""),
          }}
        />
      </StyledShippingBanner>
      <LanguageMenu />
    </StyledWrapper>
  );
}
